import {APIv1} from '../api'

export const USER_STORAGE_UPDATED_EVENT = 'user-storage-updated'

export const getStoredUser = () => {
    try {
        return JSON.parse(localStorage.getItem('user') || '{}')
    } catch (err) {
        console.error('Something went wrong reading stored user:', err)
        return {}
    }
}

export const normalizeUserData = data => {
    if (!data) return data

    const nextData = {
        ...data,
        is_head: data.is_head === true,
        is_admin: Boolean(data.is_admin ?? data.is_staff),
    }

    delete nextData.is_staff

    return nextData
}

export const normalizeStoredUser = user => {
    if (!user) return user

    return {
        ...user,
        data: normalizeUserData(user.data),
    }
}

export const saveStoredUser = user => {
    const normalizedUser = normalizeStoredUser(user)

    localStorage.setItem('user', JSON.stringify(normalizedUser))
    window.dispatchEvent(new Event(USER_STORAGE_UPDATED_EVENT))

    return normalizedUser
}

export const resolveIsEditPermission = data =>
    Boolean(data?.is_edit ?? data?.data?.is_edit ?? data?.user?.is_edit)

export const fetchUserPermissions = async (user = getStoredUser()) => {
    const token = user?.token
    const username = user?.data?.username ?? user?.username

    if (!token) {
        return {
            is_edit: false,
            user: null,
        }
    }

    try {
        const endpoint = username
            ? `/user/me/${encodeURIComponent(username)}/`
            : '/user/me/'
        const response = await APIv1.get(endpoint, {
            headers: {
                Authorization: `Token ${token}`,
            },
        })

        return {
            is_edit: resolveIsEditPermission(response.data),
            user: response.data,
        }
    } catch (err) {
        console.error('Something went wrong fetching user permissions:', err)
        return {
            is_edit: resolveIsEditPermission(user?.data ?? user),
            user: user?.data ?? user,
        }
    }
}

export const refreshStoredUser = async (user = getStoredUser()) => {
    const token = user?.token
    const username = user?.data?.username ?? user?.username

    if (!token || !username) {
        return saveStoredUser(user)
    }

    try {
        const response = await APIv1.get(`/user/me/${encodeURIComponent(username)}/`, {
            headers: {
                Authorization: `Token ${token}`,
            },
        })

        return saveStoredUser({
            ...user,
            data: {
                ...user.data,
                ...response.data,
            },
        })
    } catch (err) {
        console.error('Something went wrong refreshing stored user:', err)
        return saveStoredUser(user)
    }
}

export const canManageOrderHistoryRange = data =>
    Boolean(data?.is_admin || data?.is_staff || data?.is_head || data?.is_superuser)
